import { levenshteinDistance } from "@redotech/util/string";

export function getSettingsSearchRank({
  search,
  label,
  terms = [],
}: {
  search: string;
  label: string;
  terms?: readonly string[];
}): number | undefined {
  const query = search.trim().toLowerCase();
  const queryTokens = tokenize(query);
  if (!queryTokens.length) {
    return undefined;
  }

  const nameTokens = tokenize(label);
  if (queryTokens.join(" ") === nameTokens.join(" ")) {
    return 1;
  }

  const nameMatches = queryTokens.every((token) =>
    nameTokens.some((nameToken) => matchesToken(token, nameToken)),
  );
  if (nameMatches) {
    const phraseMatches = nameTokens.some((_, start) =>
      queryTokens.every((token, index) =>
        matchesToken(token, nameTokens[start + index] ?? ""),
      ),
    );
    return phraseMatches ? 2 : 3;
  }

  const recordTokens = [...nameTokens, ...terms.flatMap(tokenize)];
  if (
    queryTokens.every((token) =>
      recordTokens.some((recordToken) => matchesToken(token, recordToken)),
    )
  ) {
    return 4;
  }

  // Only names allow typos; other fields must still match without fuzziness.
  if (
    queryTokens.every(
      (token) =>
        recordTokens.some((recordToken) => matchesToken(token, recordToken)) ||
        nameTokens.some(
          (nameToken) =>
            Math.abs(token.length - nameToken.length) <= 1 &&
            levenshteinDistance(token, nameToken) <= 1,
        ),
    )
  ) {
    return 5;
  }
  return undefined;
}

function tokenize(value: string): string[] {
  return value.toLowerCase().match(/[a-z0-9]+/g) ?? [];
}

function matchesToken(query: string, value: string): boolean {
  return value.startsWith(query);
}
